// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.languageDisplaySelector {
    width: 148px;
    padding: 3px;
    font-size: 11px;
    border-radius: 5px;
    outline: none;
    border: 1px solid var(--PriceSelectorBorder);
    background-color: var(--filterColorElse);
    color: gray;
    cursor: pointer;
}

.languageDisplaySelector option {
    background-color: var(--PriceSelectorOptionsBackground);
    color: var(--PriceSelectorSelectColor);
    border-radius: 5px;
    outline: none;
}

.languageDisplaySelector option:checked,
option:hover {
    background-color: var(--PriceSelectorSelectColor);
    color: white;
    border-radius: 5px;
    outline: none;
}

.languageDisplaySelector option:focus {
    background-color: var(--PriceSelectorSelectColor);
    color: white;
    border-radius: 5px;
    outline: none;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Settings/AccountSettings/languageDisplay/languageDisplay.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,4CAA4C;IAC5C,wCAAwC;IACxC,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,uDAAuD;IACvD,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;AACjB;;AAEA;;IAEI,iDAAiD;IACjD,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,iDAAiD;IACjD,YAAY;IACZ,kBAAkB;IAClB,aAAa;AACjB","sourcesContent":[".languageDisplaySelector {\n    width: 148px;\n    padding: 3px;\n    font-size: 11px;\n    border-radius: 5px;\n    outline: none;\n    border: 1px solid var(--PriceSelectorBorder);\n    background-color: var(--filterColorElse);\n    color: gray;\n    cursor: pointer;\n}\n\n.languageDisplaySelector option {\n    background-color: var(--PriceSelectorOptionsBackground);\n    color: var(--PriceSelectorSelectColor);\n    border-radius: 5px;\n    outline: none;\n}\n\n.languageDisplaySelector option:checked,\noption:hover {\n    background-color: var(--PriceSelectorSelectColor);\n    color: white;\n    border-radius: 5px;\n    outline: none;\n}\n\n.languageDisplaySelector option:focus {\n    background-color: var(--PriceSelectorSelectColor);\n    color: white;\n    border-radius: 5px;\n    outline: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
